import { fetchJson } from 'src/utils/fetch';

const sendSmsVerifyCode = (data) => {
  return fetchJson({
    url: '/api/v1/bops/sendSmsVerifyCode',
    type: 'POST',
    data,
  });
};

// 登录或注册
const signIn = (data, headers = {}) => {
  return fetchJson({
    url: '/api/v1/account/auth/signIn',
    type: 'POST',
    data,
    headers,
  });
};

// 直营authCode校验
const zaAppAuthCodeToSession = (data) => {
  return fetchJson({
    url: `/api/v1/account/zaApp/auth/authCode2Session?authCode=${data.authCode}`,
    type: 'POST',
  });
};

// 健康险 OAuth 登录
const zaHealthAuthCodeToSession = (data) => {
  return fetchJson({
    url: `/api/v1/account/zaHealth/auth/authCode2Session?authCode=${data.authCode}`,
    type: 'POST',
  });
};

// 医护之家 OAuth 登录
const yihuAuthCodeToSession = (data) => {
  return fetchJson({
    url: `/api/v1/account/yihu/auth/authCode2Session?authCode=${data.authCode}`,
    type: 'POST',
  });
};

/**
 * @description 翼支付 OAuth 登录
 * @param data
 * @returns
 */
const bestpayAuthCodeToSession = (data) => {
  return fetchJson({
    url: `/api/v1/account/bestPay/auth/authCode2Session?authCode=${data.authCode}&grantType=${data.grantType}`,
    type: 'POST',
    noRelogin: true,
  });
};

/**
 * @description 统一登录 - 登录凭证校验
 * @param data
 * @returns
 */
const commonAuthCode2Session = (data) => {
  return fetchJson({
    url: '/api/v1/account/common/auth/authCode2Session',
    type: 'POST',
    search: data,
    noRelogin: true,
  });
};

const queryMgByToken = () => {
  return fetchJson({
    url: '/api/v1/bops/user/mg/queryMgByToken',
    type: 'GET',
  });
};

/**
 * 方伞code换用户信息
 * @param data
 * @returns
 */
const authCode2UserInfo = (data) => {
  return fetchJson({
    url: '/api/v1/account/fs/user/authCode2UserInfo',
    type: 'POST',
    data,
  });
};

/**
 * 方伞openid关联用户
 * @param data
 * @returns
 */
const openidRelateUser = (data) => {
  return fetchJson({
    url: '/api/v1/account/fs/user/openidRelateUser',
    type: 'POST',
    data,
  });
};

export {
  authCode2UserInfo,
  bestpayAuthCodeToSession,
  commonAuthCode2Session,
  openidRelateUser,
  queryMgByToken,
  sendSmsVerifyCode,
  signIn,
  yihuAuthCodeToSession,
  zaAppAuthCodeToSession,
  zaHealthAuthCodeToSession,
};
